import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconName } from '@panaya/ui/p-icon';
import { ColorName } from '@panaya/ui/styles-to-code';

@Component({
    selector: 'p-field',
    templateUrl: './p-field.component.html',
    styleUrls: ['./p-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PFieldComponent {
    @Input() public label?: string;
    @Input() public labelTooltip? = '';
    @Input() public shouldShowLabel? = true;
    @Input() public shouldTransformLabelTextCase? = true;
    @Input() public labelOnLeft? = true;
    @Input() public isMandatory? = false;
    @Input() public isReadOnly? = false;
    @Input() public isDisable? = false;
    @Input() public customClasses?: string;
    @Input() public preLabelIcon?: IconName;
    @Input() public preLabelIconColor!: ColorName;
    @Input() public actionIconName?: IconName;
    @Input() public actionIconTooltip?: string;
    @Input() public actionIconUrl?: string;
    @Input() public test?: string;
    @Output() public actionIconClicked = new EventEmitter<void>();

    protected get isEditable(): boolean {
        return !this.isReadOnly && !this.isDisable;
    }

    protected showLeftLabel(): this is { label: string; shouldShowLabel: true; labelOnLeft: true } {
        return Boolean(this.label && this.shouldShowLabel && this.labelOnLeft);
    }

    protected showRightLabel(): this is { label: string; shouldShowLabel: true; labelOnLeft: false } {
        return Boolean(this.label && this.shouldShowLabel && !this.labelOnLeft);
    }

    public onActionIconClick(event: Event): void {
        if (this.actionIconClicked && !this.actionIconUrl) {
            this.actionIconClicked.emit();
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
